import { createReducer } from "@reduxjs/toolkit";
import { retrieveImpersonationCandidates } from "./retrieve-impersonation-candidates";
import type { ImpersonationCandidateVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<ImpersonationCandidateVM[]> = { fetching: "idle", data: [] };

export const retrieveImpersonationCandidatesReducer = createReducer<RetrievalState<ImpersonationCandidateVM[]>>(initialState, builder => {
  builder.addCase(retrieveImpersonationCandidates.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveImpersonationCandidates.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveImpersonationCandidates.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
